let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jaV8G")).then(() => parcelRequire('0Xemw'));